import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Language, getLanguageFromLocale } from 'src/app/models/enums/language.enum';
import { IPartnerConfig } from 'src/app/models/partner-config.model';
import { LOCALE_ID, Inject } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { BookingService } from 'src/app/services/booking.service';
import { SoloModeProvider } from 'src/app/providers/solo-mode.provider';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  Language = Language;

  @ViewChild('navbar') navbar;
  @Input() public fixedHeader = false;
  @Input() public footerLogo = false;
  @Input() public selectedContentLanguage: Language;
  @Input() public isMultilanguage: boolean = false;
  public isScrolled: boolean;
  public pageConfig: IPartnerConfig;

  public cartLeght$: Observable<number>;
  isSoloMode: boolean;

  @HostListener('window:scroll')
  scrollHandler() {
    this.isScrolled = window.pageYOffset > this.navbar.nativeElement.offsetHeight;
  }

  private _productIds: number[];

  constructor(
    private cartService: CartService,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    public booking: BookingService,
    private soloModeProvider: SoloModeProvider,
    @Inject(LOCALE_ID) private locale: string
  ) {
    let productIds: string[] = [];

    if (this.route.snapshot.queryParamMap.has('productIds')) {
      productIds = this.route.snapshot.queryParamMap.get('productIds').split(',');
    } else if (this.route.snapshot.params['id']) {
      productIds = [this.route.snapshot.params['id']];
    }

    this._productIds = productIds.map((productId) => Number.parseInt(productId, 10));
  }

  ngOnInit() {
    this.isSoloMode = this.soloModeProvider.isSoloMode;

    if (this._productIds.some((productId) => isNaN(productId))) {
      this.navigationService.goToNotFound();

      return;
    }

    this.setInitialContentLanguage();
    this.cartLeght$ = this.cartService.getList().pipe(map((resp) => resp.length));
  }

  private setInitialContentLanguage() {
    const languageFromParam = this.route.snapshot.queryParamMap.get('contentLang') as Language;
    const languageFromUiLocale = getLanguageFromLocale(this.locale);
    const contentLanguage = languageFromParam || languageFromUiLocale;

    this.setContentLanguage(contentLanguage);
  }

  public setContentLanguage(language: Language) {
    this.selectedContentLanguage = language;
    this.booking.setProduct(this._productIds, language);
  }

  public openCart() {
    this.navigationService.goToCart();
  }
}
